export enum ScheduleHistoryEntryAction {
  ASSIGN = 'ASSIGN',
  UNASSIGN = 'UNASSIGN',
  MOVE = 'MOVE',
  SWAP = 'SWAP',
  LOCK = 'LOCK',
  UNLOCK = 'UNLOCK',
  REPLACE = 'REPLACE'
}
